import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { LIVE_LINK } from '../helpers/url_helper'

export const ordersApi = createApi({
  reducerPath: 'ordersApi',
  baseQuery: fetchBaseQuery({ baseUrl: `${LIVE_LINK}/orders` }),
  tagTypes: ['requests'],
  endpoints: (build) => ({
    fetchPaymentRequests: build.query({
      query: (id) => ({
        url: `/payoneer/${id}`,
      }),
    }),
    filterPaymentRequests: build.query({
      // If your backend uses POST /orders/payoneer/:id/filter
      query: ({ id, filterFormValues }) => ({
        url: '/payoneer/filtered',
        method: 'POST',
        body: filterFormValues,
      }),
      // providesTags: (result, error, { id }) =>
      //   result && result.requests
      //     ? [
      //         ...result.requests.map((r) => ({ type: 'requests', id: r._id })),
      //         { type: 'requests', id: 'LIST' },
      //       ]
      //     : [{ type: 'requests', id: 'LIST' }],
    }),
    generatePaymentRequest: build.mutation({
      query: ({ formData }) => {
        return {
          url: '/payoneer/paymentlink',
          method: 'POST',
          body: formData
        }
      },
      async onQueryStarted({ id, formData, dbData }, { dispatch, queryFulfilled }) {
        const { data } = await queryFulfilled;
        let patchResult = '';
        if (data) {
          patchResult = dispatch(
            ordersApi.util.updateQueryData('fetchPaymentRequests', id, (draft) => {
              const formattedRow = { ...dbData, _id: data._id, createdAt: data.createdAt, clientReferenceId: data.clientReferenceId, paymentRequestId: data.paymentRequestId, paymentLink: data.paymentLink, manager: data.manager };
              draft.requests.push(formattedRow);
            })
          );
        }
        try {
          await queryFulfilled;
        } catch {
          patchResult.undo(); // Revert optimistic deletion on failure
        }
      }
    })
  })
});